import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import ServiceForm from "./ServiceForm";

export default function AddService({ name }) {
    return (
        <CustomCard title={name}>
            <ServiceForm type="ADD" />
        </CustomCard>
    );
}
